<div class="ngsild-home">
  <div class="ngsild-home__stepper">
    @for (step of steps(); track step.key; let i = $index) {
      <div
        class="ngsild-home__step"
        [class.ngsild-home__step--active]="isStepActive(i)"
        [class.ngsild-home__step--completed]="isStepCompleted(i)"
        [class.ngsild-home__step--clickable]="isStepClickable(i)"
        (click)="onStepClick(i)"
      >
        <div class="ngsild-home__step-circle">
          @if (isStepCompleted(i)) {
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          } @else {
            <span>{{ i + 1 }}</span>
          }
        </div>
        <span class="ngsild-home__step-label">{{ step.label }}</span>
        @if (i < steps().length - 1) {
          <div
            class="ngsild-home__step-connector"
            [class.ngsild-home__step-connector--completed]="isStepCompleted(i + 1) || isStepActive(i + 1)"
          ></div>
        }
      </div>
    }
  </div>

  <lib-resource-server-summary
    [resourceServer]="resourceServer()"
    [ogcOnboardingMode]="ogcOnboardingMode()"
  />

  <div class="ngsild-home__main">
    <div class="ngsild-home__panel">
      <!-- Keep both steps mounted so Submit always has basic + metadata (destroying step 1 left basicInfo null). -->
      <div class="ngsild-home__step-panel" [hidden]="currentStep() !== 0">
        <lib-ngsild-basic-info
          (validChange)="onBasicValidChange($event)"
          (valueChange)="onBasicValueChange($event)"
        />
      </div>
      <div class="ngsild-home__step-panel" [hidden]="currentStep() !== 1">
        <lib-ngsild-metadata-info
          [isOgcFeature]="isOgcFeature()"
          (validChange)="onMetadataValidChange($event)"
          (valueChange)="onMetadataValueChange($event)"
        />
      </div>
      @if (isOgcRaster()) {
        <div class="ngsild-home__step-panel" [hidden]="currentStep() < 2">
          <lib-stac-collection-onboarding
            flowScope="embedded"
            [embeddedStep]="currentStep() === 2 ? 'collection' : 'item'"
            [itemId]="createdItemId()"
            [datasetTitle]="basicInfo()?.title ?? ''"
            [datasetDescription]="basicInfo()?.shortDescription ?? basicInfo()?.longDescription ?? ''"
            (collectionStepComplete)="onStacCollectionStepComplete($event)"
            (itemStepComplete)="onStacItemStepComplete($event)"
            (onboardingError)="onStacOnboardingError($event)"
          />
        </div>
      }
    </div>

    <div class="ngsild-home__actions">
      @if (canGoBack()) {
        <button
          type="button"
          class="ngsild-home__btn ngsild-home__btn--secondary"
          [disabled]="isSubmitting()"
          (click)="onBackClick()"
        >
          {{ currentStep() > 0 ? '← Previous' : '← Back' }}
        </button>
      }
      <button
        type="button"
        class="ngsild-home__btn ngsild-home__btn--primary"
        [disabled]="!canGoNext()"
        (click)="onNextClick()"
      >
        {{ nextButtonLabel() }}
      </button>
    </div>
  </div>
</div>
